import { app } from '../../../../bootstrap/core';
import { receivedPaymentFormComponent } from './receivedPaymentForm.component';
import { ReceivedPaymentFormFields } from './receivedPaymentForm.constants';

app.component('receivedPaymentForm', receivedPaymentFormComponent);
app.value('receivedPaymentFormFields', ReceivedPaymentFormFields);
